import { render, staticRenderFns } from "./DFe.vue?vue&type=template&id=047df2f4&scoped=true"
import script from "./DFe.vue?vue&type=script&lang=js"
export * from "./DFe.vue?vue&type=script&lang=js"
import style0 from "./DFe.vue?vue&type=style&index=0&id=047df2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047df2f4",
  null
  
)

export default component.exports